<template>
  <a-modal title="编辑成品" visible @cancel="cancel">
    <ak-inputs v-model="data" :options="options" ref="input" />
    <template slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" @click="submit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import NP from 'number-precision'
export default {
  props: {
    record: Object,
    vm: Object
  },
  data () {
    return {
      data: {
        name: this.record.name,
        content: this.record.content,
        describe: this.record.describe,
        price: 0
      },
      options: [
        {
          name: 'name',
          note: '型号',
          type: 'String',
        },
        {
          name: 'content',
          note: '含量',
          type: 'String',
        },
        {
          name: 'price',
          note: '公布价',
          type: 'Number',
          disabled: true
        },
        {
          name: 'describe',
          note: '描述',
          type: 'String',
        },
      ],
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    async getData () {
      let adjustment = 0
      let incidental = 0
      let profit = 0
      let total = 0
      if (this.record.adjustment) { adjustment = this.record.adjustment }
      // 获取附加费
      let sur = await this.$tkParse.getData('/classes/surcharge', {
        params: {
          where: {
            type: 'finish',
            proportion: (this.record.proportion ? this.record.proportion.objectId : '')
          }
        }
      }).catch(e => { })
      if (sur.results.length) {
        incidental = sur.results[0].incidental
        profit = sur.results[0].profit
      }
      if (!(this.record && this.record.formula)) {
        let totalPrice = 0
        totalPrice = NP.plus(incidental, profit, total, adjustment)
        this.data.price = NP.round(totalPrice, 2)
        return
      }
      let w = 0
      this.record.formula.forEach((f) => {
        if (f.weight) { w = NP.plus(w, f.weight) }
      })
      let res = []
      let par = []
      // 获取原材料
      if (this.record.rawMaterialId && this.record.rawMaterialId.length) {
        let r = await this.$tkParse.getData('/classes/rawMaterial', {
          params: {
            where: {
              objectId: { $in: this.record.rawMaterialId }
            }
          }
        }).catch(e => { })
        res = r.results
      }
      // 获取半成品
      if (this.record.partsId && this.record.partsId.length) {
        let p = await this.$tkParse.getData('/classes/parts', {
          params: {
            where: {
              objectId: { $in: this.record.partsId }
            }
          }
        }).catch(e => { })
        par = p.results
      }
      // 计算材料费
      if (res.length || par.length) {
        this.record.formula.forEach((e) => {
          let rt = NP.divide(e.weight, w, 0.01)
          e.ratio = NP.round(rt, 2)
          e.tonWeight = NP.times(e.ratio, 10)
          if (e.rawMaterial) {
            let s = res.filter((f) => { return e.rawMaterial === f.objectId })
            e.price = NP.times(s[0].price, s[0].rate, e.tonWeight, 0.001, 0.01)
            total = NP.plus(total, e.price)
          }
          if (e.parts) {
            let s = par.filter((g) => { return e.parts === g.objectId })
            e.price = NP.times(s[0].price, e.tonWeight, 0.001)
            total = NP.plus(total, e.price)
          }
        }, this)
      }
      let totalPrice = 0
      totalPrice = NP.plus(incidental, profit, total, adjustment)
      this.data.price = NP.round(totalPrice, 2)
    },
    async submit () {
      delete this.data.price
      let rs = await this.$tkParse.put(`/classes/finishProduct/${this.record.objectId}`, this.data).catch(e => {
        this.$nitification['error']({
          message: '网络错误',
          description: '网络错误请重试'
        })
      })
      if (rs) {
        this.$notification['success']({
          message: '操作成功',
          description: '成品信息已修改'
        })
      }
      this.$emit('complete')
      this.vm.refresh()
    },
    cancel () {
      this.$emit('complete', 'cancel')
    }
  }
}
</script>

<style>

</style>
